import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Configurações Fiscais',
    path: '/financial/fiscalSettings',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
